import { render } from "./AppSubmenu.vue?vue&type=template&id=0c6a0c9e&scoped=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import "./AppSubmenu.vue?vue&type=style&index=0&id=0c6a0c9e&lang=scss&scoped=true"

import exportComponent from "/Users/coolio/Documents/proyectos/karga/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6a0c9e"]])

export default __exports__